import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { ProjConstants } from './proj.constant';
import { MapConstants } from './map.constant';
import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { HttperrorhandlerService } from '../main/shared/http/httperrorhandler.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  index: Subject<any> = new Subject();
  coldwaveIndex$ = new Subject<any>();
heatwaveIndex$ = new Subject<any>();
    pointHazardData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  shortLongRange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  modelDate: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  minMax: BehaviorSubject<String> = new BehaviorSubject<String>('Max');
  minMaxToggle: BehaviorSubject<string> = new BehaviorSubject<string>('max');
  adminBasin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  ruralUrban: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  imdEcmwf: BehaviorSubject<String> = new BehaviorSubject<String>('IMD');
  seamlessSource: BehaviorSubject<String> = new BehaviorSubject<String>('IMD_RADAR_MODEL_INPUT_NOWCAST');
  dateRange: BehaviorSubject<String> = new BehaviorSubject<String>('Live Weather');
  popUpData: BehaviorSubject<object> = new BehaviorSubject<object>({ location: 'Vijayawada' });
  forecastLength: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  forecastLengthCurrent: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  blocksArray: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  revalidateMap: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  villageLayer: BehaviorSubject<object> = new BehaviorSubject<object>({});
  villageData: BehaviorSubject<object> = new BehaviorSubject<object>({});
  private ULBLayer: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public selectedULB: BehaviorSubject<object> = new BehaviorSubject<object>({});
  latLong: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  public districtClicked = new Subject<any>();
  public districtClickedUUID = new Subject<any>();
  public timeStamp = new Subject<any>();
  public districtSClicked = new Subject<any>();
  public mandalClicked = new Subject<any>();
  public stateClicked = new Subject<any>();
  public stateClickedName = new Subject<any>();
  public stateClickedNameTable = new Subject<any>();
  public districtClickedNameTable = new Subject<any>();
  public breadcrumbTableClick = new Subject<any>();
  public countryClicked = new Subject<any>();
  public countryNameClicked = new Subject<any>();
  public timestamp: BehaviorSubject<Number> = new BehaviorSubject<Number>(null);
  public currentComponent: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  searchBarChartData: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  public bottomBarClosed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public schoolCheckBoxClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public CheckBoxAngaClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public CheckBoxHealthCareClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public cwschoolCheckBoxClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public cwCheckBoxAngaClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public cwCheckBoxHealthCareClicked: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public cwCheckBoxAgriMaskClicked: BehaviorSubject<any> =  new BehaviorSubject<any>(null);
  public cwCheckBoxWheatMaskClicked: BehaviorSubject<any> =  new BehaviorSubject<any>(null);
  public cwWindLayerToggle: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public fogDistrictLayerToggle: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public fogAvaitionLayerToggle: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public fogRailwayLayerToggle: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public fogHighwayLayerToggle: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public setViewForFogAlert: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public setViewForNHIPAlert: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public nhipTimeRangeChange: Subject<string> = new Subject<string>();
  public nhipInfoboxReset: Subject<void> = new Subject<void>();
  public enableFogSectorLayer: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public nhipLayerToggle: Subject<string> = new Subject<string>();
  public thresholdMap: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public queryParams: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public paramsforDrought: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public paramsforFlood: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public districtClickedDrought: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public detEnsmbl: BehaviorSubject<string> = new BehaviorSubject<string>('ensemble');
  public meanMedian: BehaviorSubject<string> = new BehaviorSubject<string>('mean');
  public cycloneForecastTypeAry: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(['deterministic', 'ensemble', 'heatmap']);
  public sourceImdEcmwf: BehaviorSubject<string> = new BehaviorSubject<string>('ECMWF');
  public cycloneComponentName: BehaviorSubject<string> = new BehaviorSubject<string>('wind speed');
  public favouriteMaps: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public favouriteMapss: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public favouriteMapName: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public disabledMaps: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public layerList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public otherOptions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public OtherTimeStamp: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public favouriteMapsOrder: BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
  public windLayerAdd: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public cycloneLayersObject: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public cycloneNamesArray: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public activeCycloneArray: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public currentBasin: BehaviorSubject<string> = new BehaviorSubject<string>('ap');
  public inflowOutflow: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public currentPlayPosition: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public showRadarData: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public sourceCloudTemp: BehaviorSubject<string> = new BehaviorSubject<string>('Rapid IMD');
  public sourceCloudCover: BehaviorSubject<string> = new BehaviorSubject<string>('Rapid IMD');
  public sourceDistrictWarnings: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public sourceHeatwave: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public sourceStationWarnings: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public radarSourceArray: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(['mausamIMD', 'rainViewer']);
  public cycloneEvent: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public cycloneDates: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public cycloneName: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public extremeWeatherSourceList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public waveDEMLayersList: BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
  public disabledDEMLayersList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public drinkingWaterData: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public sourceListForWF: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showLoginBox: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public language: BehaviorSubject<string> = new BehaviorSubject<string>('en');
  public lightningDetails: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public showHomeButton: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public currentLatLong: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public observedWeatherSource: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public lastProcessedTime: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public floodData: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public radarSourceVal : BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public showDownload: BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
  public setHeatWaveSource: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private showFullScreenViewSubject = new BehaviorSubject<boolean>(false);
  public nowcastView: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public layerType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public nowcastTimeStamp: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public locationData: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public gisMapComp: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public sourceAlert: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public seamlessLabelStrings: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public setMap: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public setInitMap: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public setInitMap1: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public setInitMap2: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public setInitMap3: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public onLocationChange = new Subject<any>();
  public catchmentLayers: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public geoData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public selectedParams: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public heatwaveMetaData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public playButton: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public stationsData: BehaviorSubject<any> = new BehaviorSubject<any>({})
  // In UtilsService, add this:
  nhipLocationMapClick: Subject<{lat: number, lng: number, locName?: string}> = new Subject();
  constructor(
    private http: HttpClient,
    private deviceDetectorService: DeviceDetectorService,
    private toastr: ToastrService,
    private errorHandler: HttperrorhandlerService,
    ) {
    this.getSRLRToggle().subscribe(value => {
      if (value === true) {
        this.timestamp.next(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING['0']);
      } else {
        this.timestamp.next(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING_LR['0']);
      }
    });
  }


  formatNames(string) {
    if (string !== undefined && string != null) {
      return string.replace(/\w\S*/g, (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
    }
  }

  setDateRange(value) {
    this.dateRange.next(value);
  }

  getDateRange() {
    return this.dateRange.asObservable();
  }

  titleCase(str) {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  setQueryParams(value) {
    this.queryParams.next(value);
  }

  getQueryParams() {
    return this.queryParams.asObservable();
  }

  setQueryParamsDrought(value) {
    this.paramsforDrought.next(value);
  }

  getQueryParamsDrought() {
    return this.paramsforDrought.asObservable();
  }

  getQueryParamsDroughtValue() {
    return this.paramsforDrought.value;
  }

  setRadarData(value) {
    this.showRadarData.next(value);
  }

  getRadarData() {
    return this.showRadarData.asObservable();
  }

  getRadarDataValue() {
    return this.showRadarData.value;
  }

  setCTsourceData(value) {
    this.sourceCloudTemp.next(value);
  }

  getCTsourceData() {
    return this.sourceCloudTemp.asObservable();
  }

  setCCsourceData(value) {
    this.sourceCloudCover.next(value);
  }

  getCCsourceData() {
    return this.sourceCloudCover.asObservable();
  }
  setDWsourceData(value) {
    this.sourceDistrictWarnings.next(value);
  }

  getDWsourceData() {
    return this.sourceDistrictWarnings.asObservable();
  }

  setRadarSourceData(value) {
    this.sourceHeatwave.next(value);
  }

  getRadarSourceData() {
    return this.sourceHeatwave.asObservable();
  }
  setSWsourceData(value) {
    this.sourceStationWarnings.next(value);
  }

  getSWsourceData() {
    return this.sourceStationWarnings.asObservable();
  }

  setDrinkingWaterData(value) {
    this.drinkingWaterData.next(value);
  }

  getDrinkingWaterData() {
    return this.drinkingWaterData.asObservable();
  }

  setULBLayer(value) {
    this.ULBLayer.next(value);
  }

  getULBLayer() {
    return this.ULBLayer.asObservable()
  }

  setULBselected(value) {
    this.selectedULB.next(value);
  }

  getULBselected() {
    return this.selectedULB.asObservable()
  }

  setvillageLayer(value) {
    this.villageLayer.next(value);
  }

  getvillageLayer() {
    return this.villageLayer.asObservable();
  }

  setvillageData(value) {
    this.villageData.next(value);
  }

  getvillageData() {
    return this.villageData.asObservable();
  }

  getCycloneEvent() {
    return this.cycloneEvent.asObservable();
  }

  setCycloneEvent(value: string) {
    this.cycloneEvent.next(value);
  }

  setcycloneDates(value) {
    this.cycloneDates.next(value);
  }

  setcycloneName(value){
    this.cycloneName.next(value);
  }

  getcycloneDates() {
    return this.cycloneDates.asObservable();
  }
  getcycloneNames() {
    return this.cycloneName.asObservable();
  }


  setQueryParamsFlood(value) {
    this.paramsforFlood.next(value);
  }

  getQueryParamsFlood() {
    return this.paramsforFlood.asObservable();
  }

  getQueryParamsFloodValue() {
    return this.paramsforFlood.value;
  }

  setdistrictDrought(value) {
    this.districtClickedDrought.next(value);
  }

  getdistrictDrought() {
    return this.districtClickedDrought.asObservable();
  }

  getdistrictDroughtValue() {
    return this.districtClickedDrought.value;
  }

  setcurrentBasin(value) {
    this.currentBasin.next(value);
  }

  getcurrentBasin() {
    return this.currentBasin.asObservable();
  }

  getcurrentBasinValue() {
    return this.currentBasin.value;
  }

  setinflowOutflow(value) {
    this.inflowOutflow.next(value);
  }

  getinflowOutflow() {
    return this.inflowOutflow.asObservable();
  }

  getinflowOutflowValue() {
    return this.inflowOutflow.value;
  }

  setLatLong(value) {
    this.latLong.next(value);
  }

  getLatLong() {
    return this.latLong.asObservable();
  }

  getQueryParamsValue() {
    return this.queryParams.value;
  }

  setBottomBarClosed(value) {
    this.bottomBarClosed.next(value);
  }

  getBottomBarClosed() {
    return this.bottomBarClosed.asObservable();
  }

  setCurrentComponent(value) {
    this.currentComponent.next(value);
  }

  getCurrentComponent() {
    return this.currentComponent.asObservable();
  }

  setTimestamp(value) {
    this.timestamp.next(value);
  }

  setIndex(index) {
    this.index.next(index);
  }

  setAdminBasinToggle(value) {
    this.adminBasin.next(value);
  }

  getAdminBasinToggle() {
    return this.adminBasin.asObservable();
  }

  setRuralUrbanToggle(value) {
    this.ruralUrban.next(value);
  }

  getRuralUrbanToggle() {
    return this.ruralUrban.asObservable();
  }

  setImdEcmwf(value) {
    this.imdEcmwf.next(value);
  }

  getIdmEcmwf() {
    return this.imdEcmwf.asObservable();
  }

  setSeamlessviewSource(value) {
    this.seamlessSource.next(value);
  }

  getSeamlessviewSource() {
    return this.seamlessSource.asObservable();
  }

  getIdmEcmwfValue() {
    return this.imdEcmwf.value;
  }

  setSRLRToggle(value) {
    this.shortLongRange.next(value);
  }

  getSRLRToggle() {
    return this.shortLongRange.asObservable();
  }

  setPopUpData(value) {
    this.popUpData.next(value);
  }

  getPopUpData() {
    return this.popUpData.asObservable();
  }

  setSearchBarChartData(value) {
    this.searchBarChartData.next(value);
  }

  getSearchBarChartData() {
    return this.searchBarChartData.asObservable();
  }

  setDistrictClicked(value) {
    this.districtClicked.next(value);
  }

  getDistrictClicked() {
    return this.districtClicked.asObservable();
  }

  setDistrictClickedUUID(value) {
    this.districtClickedUUID.next(value);
  }

  getDistrictClickedUUID() {
    return this.districtClickedUUID.asObservable();
  }
  setDistrictsClicked(value) {
    this.districtSClicked.next(value);
  }

  getTimeStamp() {
    return this.timeStamp.asObservable();
  }
  setTimeStamp(value) {
    this.timeStamp.next(value);
  }

  // getCheckBoxClicked() {
  //   return this.CheckBoxClicked.asObservable();
  // }
  setCheckBoxClicked(value) {
    this.schoolCheckBoxClicked.next(value);
  }

  setCheckBoxAngaClicked(value) {
    this.CheckBoxAngaClicked.next(value);
  }

  setCheckBoxHealthCareClicked(value) {
    this.CheckBoxHealthCareClicked.next(value);
  }

  getDistrictsClicked() {
    return this.districtSClicked.asObservable();
  }
  setMandalClicked(value) {
    this.mandalClicked.next(value);
  }

  getMandalClicked() {
    return this.mandalClicked.asObservable();
  }
  setStateClicked(value) {
    this.stateClicked.next(value);
  }

  getStateClicked() {
    return this.stateClicked.asObservable();
  }
  setStateClickedName(value) {
    this.stateClickedName.next(value);
  }

  getStateClickedName() {
    return this.stateClickedName.asObservable();
  }
  setStateClickedNameTable(value) {
    this.stateClickedNameTable.next(value);
  }

  getStateClickedNameTable() {
    return this.stateClickedNameTable.asObservable();
  }
  setDistrictClickedNameTable(value) {
    this.districtClickedNameTable.next(value);
  }



  getDistrictClickedNameTable() {
    return this.districtClickedNameTable.asObservable();
  }
  setBreadcrumbClick(value) {
    this.breadcrumbTableClick.next(value);
  }



  getBreadcrumbClick() {
    return this.breadcrumbTableClick.asObservable();
  }
  setCountryClicked(value) {
    this.countryClicked.next(value);
  }

  getCountryClicked() {
    return this.countryClicked.asObservable();
  }
  setCountryNameClicked(value) {
    this.countryNameClicked.next(value);
  }

  getCountryNameClicked() {
    return this.countryNameClicked.asObservable();
  }

  setObservedWeathersourceData(value) {
    this.observedWeatherSource.next(value);
  }

  getObservedWeathersourceData() {
    return this.observedWeatherSource.asObservable();
  }

  setLastProcessedTime(value) {
    this.lastProcessedTime.next(value);
  }

  getLastProcessedTime() {
    return this.lastProcessedTime.asObservable();
  }

  setShowDownload(value){
    this.showDownload.next(value);
  }

  getShowDownload(){
    return this.showDownload.asObservable();
  }

  setFloodData(value){
    this.floodData.next(value);
  }

  getFloodData(){
    return this.floodData.asObservable();
  }
  setRadarCTCSrc(value){
    this.radarSourceVal.next(value);
  }
  getRadarCTCSrc(){
    return this.radarSourceVal.asObservable();
  }

  setShowFullScreenView(value: boolean){
    this.showFullScreenViewSubject.next(value);
  }
  getShowFullScreenView(): Observable<boolean>{
    return this.showFullScreenViewSubject.asObservable();
  }

  setNowcastTimestamp(value){
    this.nowcastTimeStamp.next(value);
  }

  getNowcastTimestamp(){
    return this.nowcastTimeStamp.asObservable();
  }

  setNowcastView(value){
    this.nowcastView.next(value);
  }

  getNowcastView(){
    return this.nowcastView.asObservable();
  }

  setLocationData(value){
    this.locationData.next(value);
  }

  getLocationData(){
    return this.locationData.asObservable();
  }


  setGisMapComp(val){
    this.gisMapComp.next(val);
  }

  getGisMapComp(){
    return this.gisMapComp.asObservable();
  }

  setSourceAlert(value){
    this.sourceAlert.next(value);
  }

  getSourceAlert(){
    return this.sourceAlert.asObservable();
  }

  setPlayButton(value) {
    this.playButton.next(value);
  }

  getPlayButton() {
    return this.playButton.asObservable();
  }

  public checkUndefinedOrNull(val) {
    // if(val != undefined && val != null){
    if (val == null)
      return '-';
    return val;
    // }else{
    //   return null;
    // }
  }

  bool:boolean=true;

  getVal(){
    return this.bool;
  }
  setVal(val:any){
    this.bool = val;
  }

  getColorForBottomBar(component, value) {
    let retval = '';
    if (component == 'RAINFALL') {
      value = Number(value);
      ProjConstants.RAINFALL_RANGES_ARRAY.forEach((item, i) => {
        if (i + 1 !== ProjConstants.RAINFALL_RANGES_ARRAY.length && Number(value) >= ProjConstants.RAINFALL_RANGES_ARRAY[i]
          && Number(value) < ProjConstants.RAINFALL_RANGES_ARRAY[i + 1]) {
          retval = ProjConstants.RAINFALL_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.RAINFALL_CATEGORIES_ARRAY[i]];
        }
      });
      if (retval == '') {
        retval = ProjConstants.RAINFALL_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.RAINFALL_CATEGORIES_ARRAY.slice(-1)[0]];
      }
    }
    if (component == 'TEMPERATURE') {
      value = Number(value);
      ProjConstants.TEMPERATURE_RANGES_ARRAY.forEach((item, i) => {
        if (i + 1 !== ProjConstants.TEMPERATURE_RANGES_ARRAY.length &&
          Number(value) >= ProjConstants.TEMPERATURE_RANGES_ARRAY[i] && Number(value) < ProjConstants.TEMPERATURE_RANGES_ARRAY[i + 1]) {
          retval = ProjConstants.TEMPERATURE_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.TEMPERATURE_CATEGORIES_ARRAY[i].split('-')[0]];
        }
      });
      if (retval == '') {
        retval = ProjConstants.TEMPERATURE_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.TEMPERATURE_CATEGORIES_ARRAY.slice(-1)[0]];
      }
    }
    if (component == 'HUMIDITY') {
      value = Number(value);
      ProjConstants.HUMIDITY_CATEGORIES_ARRAY.forEach((item, i) => {
        if (i + 1 !== ProjConstants.HUMIDITY_CATEGORIES_ARRAY.length &&
          Number(value) >= ProjConstants.HUMIDITY_CATEGORIES_ARRAY[i] && Number(value) < ProjConstants.HUMIDITY_CATEGORIES_ARRAY[i + 1]) {
          retval = ProjConstants.HUMIDITY_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.HUMIDITY_RANGES_ARRAY[i]];
        }
      });
      if (retval == '') {
        retval = ProjConstants.HUMIDITY_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.HUMIDITY_RANGES_ARRAY.slice(-1)[0]];
      }
    }
    if (component == 'WINDSPEED') {
      value = Number(value);
      ProjConstants.WINDSPEED_RANGES_ARRAY.forEach((item, i) => {
        if (i + 1 !== ProjConstants.WINDSPEED_RANGES_ARRAY.length &&
          Number(value) >= ProjConstants.WINDSPEED_RANGES_ARRAY[i] && Number(value) < ProjConstants.WINDSPEED_RANGES_ARRAY[i + 1]) {
          retval = ProjConstants.WINDSPEED_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.WINDSPEED_CATEGORIES_ARRAY[i]];
        }
      });
      if (retval == '') {
        retval = ProjConstants.WINDSPEED_CHART_RANGE_TO_COLOR_MAPPING[ProjConstants.WINDSPEED_CATEGORIES_ARRAY.slice(-1)[0]];
      }
    }
    return retval;
  }

  setBlocksArray(value) {
    this.blocksArray.next(value);
  }

  getBlocksArray() {
    return this.blocksArray.asObservable();
  }

  convertHexToRGBA(hex) {
    hex = hex.split('#')[1];
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const result = 'rgba(' + r + ',' + g + ',' + b + ',' + 0.6 + ')';
    return result;
  }

  setForecastLengthChanged(value) {
    this.forecastLength.next(value);
  }

  getForecastLengthChanged() {
    return this.forecastLength.asObservable();
  }

  setCurrentForecastLength(value) {
    this.forecastLengthCurrent.next(value);
  }

  getCurrentForecastLength() {
    return this.forecastLengthCurrent.asObservable;
  }

  getStateUUID(stateUrlId) {
    return ProjConstants.IDTOUUIDMAPPING[stateUrlId];
  }

  getStateName(stateUrlId) {
    return ProjConstants.IDTOSTATENAMEMAPPING[stateUrlId];
  }

  convertModelDatetoDate(date) {
    date = date.toString();
    if (date.length == 8) {
      const year = date[0] + date[1] + date[2] + date[3];
      const month = date[4] + date[5] - 1;
      const day = date[6] + date[7];
      return new Date(Number(year), Number(month), Number(day));
    }
    return new Date(date);
  }
  convertModelDatetoDates(date) {
    date = date.toString();
    if (date.length == 8) {
      const year = date[0] + date[1] + date[2] + date[3];
      const month = date[4] + date[5] - 1;
      const day = date[6] + date[7];
      return new Date(Number(year), Number(month), Number(day));
    }
    return new Date(date);
  }
  convertModelDatetoDateForMobile(date) {
    date = date.toString();
    if (date) {
      const year = date[0] + date[1] + date[2] + date[3];
      const month = date[4] + date[5] - 1;
      const day = date[6] + date[7];
      return new Date(Number(year), Number(month), Number(day));
    }
    // return new Date(date);
  }

  get24HrsTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    const blocks = {};
    for (let i = 0; i < 4; i++) {
      blocks[i] = dayStartTs + ((i + blockIndex) * 21600000);
    }
    blocks[4] = blocks[0];
    return blocks;
  }

  get10DaysTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = dayStartTs + ((i + 1) * 86400000);
    }
    return blocks;
  }

  sortD(data, columnName) {
    let i, j;
    const key = {};
    for (i = 1; i < data.length; i++) {
      Object.assign(key, data[i]);
      j = i - 1;
      while (j >= 0 && (data[j][columnName] < key[columnName])) {
        Object.assign(data[j + 1], data[j]);
        j = j - 1;
      }
      Object.assign(data[j + 1], key);
    }
  }

  sortA(data, columnName) {
    // function to sort dataTable
    // if (data == this.dataSource) {
    //   this.dataSource = data;
    // }
    let i, j;
    const key = {};
    for (i = 1; i < data.length; i++) {
      Object.assign(key, data[i]);
      j = i - 1;
      while (j >= 0 && (data[j][columnName] > key[columnName])) {
        Object.assign(data[j + 1], data[j]);
        j = j - 1;
      }
      Object.assign(data[j + 1], key);
    }
  }

  getLocation(callBackFunction, errorFunction) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        callBackFunction(position);
      }, error => {
        errorFunction(error);
      });
    } else {
      // alert("Geolocation is not supported by this browser.");
      errorFunction('Geolocation is not supported by this browser.');
    }
  }

  getLocationLayerData(callBackFunction, errorFunction, layerName) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.getLocationLayerDataFromLatLong(position.coords.latitude, position.coords.longitude, layerName).subscribe(data => {
          callBackFunction(data);
        });
      }, error => {
        errorFunction(error);
      });
    } else {
      // alert("Geolocation is not supported by this browser.");
      errorFunction('Geolocation is not supported by this browser.');
    }
  }

  getLocationLayerDataFromLatLong(latitude, longitude, layerName) {
    let url = MapConstants.GEOSERVER_WMFS_URL + MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + layerName;
    url = url + '&CQL_FILTER=CONTAINS(geom, POINT (' + longitude.toString() + ' ' + latitude.toString() + '))';
    return this.http.get(url);
  }

  getDeterministicOrEnsemble() {
    return this.detEnsmbl.asObservable();
  }

  setDetermisnisticOrEnsemble(value: any) {
    this.detEnsmbl.next(value);
  }

  getmeanMedian() {
    return this.meanMedian.asObservable();
  }

  setmeanMedian(value: any) {
    this.meanMedian.next(value);
  }

  setModelDate(value: any) {
    this.modelDate.next(value);
  }

  getModelDate() {
    return this.modelDate.asObservable();
  }

  getModelDateValue() {
    return this.modelDate.value;
  }

  getCycloneForecastTypeArray() {
    return this.cycloneForecastTypeAry.asObservable();
  }

  setCycloneForecastTypeArray(value: any) {
    this.cycloneForecastTypeAry.next(value);
  }

  getSourceToggle() {
    return this.sourceImdEcmwf.asObservable();
  }

  setSourceToggle(value: any) {
    this.sourceImdEcmwf.next(value);
  }

  getCycloneComponentName() {
    return this.cycloneComponentName.asObservable();
  }

  setCycloneComponentName(value: any) {
    this.cycloneComponentName.next(value);
  }

  getFavouriteMaps() {
    return this.favouriteMaps.asObservable();
  }

  setFavouriteMaps(value: any) {
    this.favouriteMaps.next(value);
  }

  getFavouriteMapName() {
    return this.favouriteMapName.asObservable();
  }

  setFavouriteMapName(value: string) {
    this.favouriteMapName.next(value);
  }

  getLayerList() {
    return this.layerList.asObservable();
  }

  setLayerList(value: any) {
    this.layerList.next(value);
  }

  getOtherOptions() {
    return this.otherOptions.asObservable();
  }

  setOtherOptions(value: any) {
    this.otherOptions.next(value);
  }

  getOtherTimeStamp() {
    return this.OtherTimeStamp.asObservable();
  }

  setOtherTimeStamp(value: any) {
    this.OtherTimeStamp.next(value);
  }

  getFavouriteMapsOrder() {
    return this.favouriteMapsOrder.asObservable();
  }

  setFavouriteMapsOrder(value: object[]) {
    this.favouriteMapsOrder.next(value);
  }

  getWindLayerAdd() {
    return this.windLayerAdd.asObservable();
  }

  setWindLayerAdd(value: any) {
    this.windLayerAdd.next(value);
  }

  getCycloneNamesArray() {
    return this.cycloneNamesArray.asObservable();
  }

  setCycloneNamesArray(value: string[]) {
    this.cycloneNamesArray.next(value);
  }

  getActiveCycloneArray() {
    return this.activeCycloneArray.asObservable();
  }

  setActiveCycloneArray(value: string[]) {
    this.activeCycloneArray.next(value);
  }

  getCurrentPlayPosition() {
    return this.currentPlayPosition.asObservable();
  }

  setCurrentPlayPosition(value: any) {
    this.currentPlayPosition.next(value);
  }

  getRadarSourceArray() {
    return this.radarSourceArray.asObservable();
  }

  setRadarSourceArray(value: string[]) {
    this.radarSourceArray.next(value);
  }

  getExtremeWeatherSourceList() {
    return this.extremeWeatherSourceList.asObservable();
  }

  setExtremeWeatherSourceList(value: string[]) {
    this.extremeWeatherSourceList.next(value);
  }

  getExtremeWeatherSourceListValue() {
    return this.extremeWeatherSourceList.value;
  }

  getWaveDEMLayersList() {
    return this.waveDEMLayersList.asObservable();
  }

  setWaveDEMLayersList(value: object[]) {
    this.waveDEMLayersList.next(value);
  }

  getDeviceType(): string {
   return this.deviceDetectorService.deviceType;
  }


  setSourceList(value) {
    this.sourceListForWF.next(value);
  }

  getSourceList() {
    return this.sourceListForWF.asObservable();
  }

  setLoginPrompt(value) {
    this.isUserLoggedIn.next(value);
  }

  getLoginPrompt() {
    return this.isUserLoggedIn.asObservable();
  }

  clearLogin(){
    localStorage.removeItem("ACCESS_TOKEN");
    localStorage.removeItem('USER_INFO')
    localStorage.removeItem('LOGIN_RESPONSE')
    this.setLoginPrompt(false);
    this.toastr.success('Log Out Successfull', '', {closeButton: true});
  }

  setShowLoginBox(value) {
    this.showLoginBox.next(value);
  }

  getShowLoginBox() {
    return this.showLoginBox.asObservable();
  }

  setLanguage(value) {
    this.language.next(value);
  }

  getLanguage() {
    return this.language.asObservable();
  }
  setLightningDetails(value) {
    this.lightningDetails.next(value);
  }

  getLightningDetails() {
    return this.lightningDetails.asObservable();
  }

  setShowHomeButton(value) {
    this.showHomeButton.next(value);
  }

  getShowHomeButton() {
    return this.showHomeButton.asObservable();
  }

  getCurrentLatLongFromLS(){
    if(localStorage.getItem("latlng"))
      return JSON.parse(localStorage.getItem("latlng"));
    else
      return {};
  }

  setCurrentLatLongFromLS(latlng){
    localStorage.setItem("latlng",JSON.stringify(latlng));
  }

  getTimeStampData() {
    let url = ProjConstants.API_URL + 'nowcast/getLatestProcessedFileNameOfNowcastSources';
    return this.http.get<any>(url)
  }

  getTimeNowcastData(postdata) {
    return this.http.post<any>(ProjConstants.API_URL + 'nowcast/getNowcastModelInputHeatMaps', postdata).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getSchooleAlertCount(postdata) {
    return this.http.post<any>(ProjConstants.API_URL + 'heatWatches/getLocTypeCategoryWiseHeatwaveCount', postdata).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getSchoolHeatWaveCategoryCount(postdata) {
    return this.http.post<any>(ProjConstants.API_URL + 'heatWatches/getHeatWatchesCountByLocType', postdata).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  convertToTimestamp(dateString: any) {
    if (!dateString) return ''
    // Extract year, month, and day from the string
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Months are 0-based in JavaScript
    const day = parseInt(dateString.substring(6, 8), 10);

    // Create a Date object
    const date = new Date(year, month, day);

    // Return the timestamp
    return date.getTime();
  }

  formatTimestampWithOffset(timestamp) {
    // Extract the year, month, and day from the timestamp
    const year = timestamp.substring(0, 4); // "2024"
    const monthIndex = parseInt(timestamp.substring(4, 6), 10) - 1; // "12" -> December (0-based index)
    const day = parseInt(timestamp.substring(6, 8), 10); // "19"

    // Create a date object in UTC
    const date = new Date(Date.UTC(year, monthIndex, day));

    // Adjust for GMT +5:30 (5 hours 30 minutes)
    const offsetMinutes = 5 * 60 + 30;
    date.setUTCMinutes(date.getUTCMinutes() + offsetMinutes);

    // Get the day, month, and year
    const formattedDay = String(date.getUTCDate()).padStart(2, '0'); // e.g., "19"
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formattedMonth = monthNames[date.getUTCMonth()]; // e.g., "Dec"
    const formattedYear = date.getUTCFullYear(); // e.g., "2024"

    // Combine into the desired format with GMT+5:30
    return `${formattedDay}-${formattedMonth}-${formattedYear} GMT+5:30`;
  }
}
